export default __webpack_public_path__ + "static/flipSectionBg-1d8a35f62133a20042a2ee836ac60cd0.png";